import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ClientsService } from 'src/app/services/clients.service';

@Component({
    selector: 'app-client-activities',
    templateUrl: './client-activities.component.html',
    styleUrl: './client-activities.component.scss',
    standalone: false
})
export class ClientActivitiesComponent implements OnInit {
	loading = true;

	logs: any[] = [];
	@Input() currentClient!: any;

	constructor(private clientsService: ClientsService, private authService: AuthService) {}

	ngOnInit(): void {
		this.clientsService.getClientLogs(this.currentClient.id).subscribe({
			next: (response: any) => {
				this.logs = response;
				this.loading = false;
			},
			error: (err) => {
				this.authService.toastErrorMessage(err.message ? err.message : err, 'Client Logs');
			}
		});
	}
}
